export const handleCustomEvent = (eventData) => {
    if (window !== undefined) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });
        window.dataLayer.push(eventData);
    }
};

export default handleCustomEvent;
